angular.module('impactx.rfq').controller('RFQEditSupplierCtrl', RFQEditSupplierCtrl);
RFQEditSupplierCtrl.$inject = [
    '$scope',
    'dataGen',
    '$route',
    '$routeParams',
    'ToastService',
    'BackService',
    'ToolbarService',
    '$mdDialog'
];

function RFQEditSupplierCtrl($scope, dataGen, $route, $routeParams, ToastService, BackService, ToolbarService, $mdDialog) {
    $scope.selectedItems = [];
    $scope.isSupplier = {value: true};
    $scope.minDate = new Date();
    var self = this;

    if ($routeParams.rfqsId > 0) {
        dataGen.getData($scope, {id: $routeParams.rfqsId}, "/rfq/viewsinglerfqssupplier").then(function () {
            $scope.buttonDefinition = [
                {label: $scope.trns.comment, action: self.toggleItemComment, type:'dialogaction', condition: self.canItemComment},
                {label: $scope.trns.comment, action: self.toggleSupplierComment, type:'dialogaction', condition: self.canSupplierComment},
                {label: $scope.trns.save, action: self.save, type:'validation', condition: self.canEdit, params: {form: $scope.dialogData}},
                {label: $scope.trns.editItem, action: self.editItem, type:'dialogaction', condition: self.canEditItem},
                {label: $scope.trns.cancelItem, action: self.cancelItem, type:'dialogaction', condition: self.canCancelItem},
                {label: $scope.trns.cancel, action: self.cancel, type:'dialogaction', condition: self.canCancelSelected},
                {label: $scope.trns.cancel, action: self.cancel, type:'dialogaction', condition: self.canCancelFirst},
                {label: $scope.trns.reply, action: self.reply, type:'validation', condition: self.canReplyFirst, params: {form: $scope.dialogData}},
                {label: $scope.trns.reply, action: self.reply, type:'validation', condition: self.canReplySelected, params: {form: $scope.dialogData}},
                {label: $scope.trns.reWork, action: self.rework, type:'dialogaction', condition: self.canReWorkFirst},
                {label: $scope.trns.reWork, action: self.rework, type:'dialogaction', condition: self.canReWorkSelected},
                {
                    label: $scope.trns.print,
                    type: 'print',
                    condition: self.canPrint,
                    params: {
                        printTokenFunction: self.getPrintToken
                    }
                }
            ];

            ToolbarService.setButtons($scope.buttonDefinition);
        });
    }

    $scope.showItemComments = {value: false};
    $scope.showSupplierComments = {value: false};
    $scope.selectedSupplier = [];

    this.toggleItemComment = function () {
        $scope.showItemComments.value = !$scope.showItemComments.value;
    };

    this.toggleSupplierComment = function () {
        $scope.showSupplierComments.value = !$scope.showSupplierComments.value;
    };

    this.selectSupplier = function (event, supplier) {
        $scope.showItemComments.value = false;
        $scope.showSupplierComments.value = false;
        for (var i = 0; i < $scope.selectedItems.length; i++) {
            $scope.selectedItems[i].selected = false;
        }
        $scope.selectedItems.splice(0, 1);

        if ($scope.selectedSupplier[0] !== supplier) {
            $scope.selectedSupplier[0] = supplier;
        }
        else {
            $scope.selectedSupplier.splice(0, 1);
        }
    };

    self.canItemComment = function()
    {
        return $scope.data.canExternalComment && $scope.selectedItems.length > 0;
    };

    self.canSupplierComment = function()
    {
        return $scope.data.canExternalComment && $scope.selectedSupplier.length > 0;
    };

    self.canEdit = function()
    {
        return !$scope.data.readOnly;
    };

    self.save = function () {
        return dataGen.postAsForm({}, {header: $scope.data}, "/rfq/savesupplier").then(function (data) {
            ToastService.openStandardToast(data.trns.success);
            BackService.back();
        });
    };

    self.canEditItem = function()
    {
        return $scope.selectedItems.length === 1 && self.canEdit() && !$scope.selectedItems[0].isCanceled;
    };

    self.canCancelItem = function()
    {
        return $scope.selectedItems.length === 1 && self.canEdit() && $scope.selectedItems[0].canCancel;
    };

    self.cancelItem = function()
    {
        $scope.selectedItems[0].doCancel = true;
        $scope.selectedItems[0].isCanceled = true;
        $scope.selectedItems[0].statusMessage = $scope.trns.statusMessageDenied;
    };

    this.cancel = function () {
        var rfqsId = 0;
        if (self.canCancelFirst()) {
            rfqsId = $scope.data.supplierHeaders[0].id;
        }
        else if (self.canCancelSelected()) {
            rfqsId = $scope.selectedSupplier[0].id;
        }
        if (rfqsId > 0) {
            return dataGen.postAsForm({}, {rfqsId: rfqsId}, "/rfq/cancelrfqssupplier").then(function (data) {
                ToastService.openStandardToast(data.trns.success);
                BackService.back();
            });
        }
    };

    self.canCancelSelected = function()
    {
        return $scope.selectedSupplier.length > 0 && $scope.selectedSupplier[0].canCancel && !$scope.selectedItems.length;
    };

    self.canCancelFirst = function()
    {
        return !$scope.selectedSupplier.length && $scope.data.supplierHeaders[0].canCancel && $scope.data.supplierHeaders.length === 1 && !$scope.selectedItems.length;
    };

    this.reply = function () {
        var rfqs = null;
        if (self.canReplyFirst()) {
            rfqs = $scope.data.supplierHeaders[0];
        }
        else if (self.canReplySelected()) {
            rfqs = $scope.selectedSupplier[0];
        }
        if (rfqs) {
            return dataGen.postAsForm({}, {rfqs: rfqs}, "/rfq/replyrfqssupplier").then(function (data) {
                ToastService.openStandardToast(data.trns.success);
                BackService.back();
            }, function (data) {
                $scope.data = data.data;
            });
        }
    };

    self.canReplySelected = function()
    {
        return $scope.selectedSupplier.length > 0 && $scope.selectedSupplier[0].canReply && !$scope.selectedItems.length;
    };

    self.canReplyFirst = function()
    {
        return !$scope.selectedSupplier.length && $scope.data.supplierHeaders[0].canReply && $scope.data.supplierHeaders.length === 1 && !$scope.selectedItems.length;
    };

    self.canPrint = function() {
        return ($scope.data.supplierHeaders.length === 1 || ($scope.selectedSupplier.length > 1 && $scope.selectedSupplier.length > 0)) && !$scope.selectedItems.length;
    };

    this.rework = function () {
        var rfqsId = 0;
        if (self.canReWorkFirst()) {
            rfqsId = $scope.data.supplierHeaders[0].id;
        }
        else if (self.canReWorkSelected()) {
            rfqsId = $scope.selectedSupplier[0].id;
        }
        if (rfqsId > 0) {
            return dataGen.postAsForm({},  {rfqsId: rfqsId}, "/rfq/reworkrfqssupplier").then(function (data) {
                ToastService.openStandardToast(data.trns.success);
                $scope.data = data.data;
            });
        }
    };

    self.canReWorkSelected = function()
    {
        return $scope.selectedSupplier.length > 0 && $scope.selectedSupplier[0].canReWork;
    };

    self.canReWorkFirst = function()
    {
        return !$scope.selectedSupplier.length && $scope.data.supplierHeaders[0].canReWork && $scope.data.supplierHeaders.length === 1;
    };

    self.editItem = function (ev) {
        var copiedItem = JSON.parse(JSON.stringify($scope.selectedItems[0]));
        $mdDialog.show({
            templateUrl: "modules/rfq/templates/changerfqitem.tmpl.html",
            controller: "RFQChangeItemCtrl",
            controllerAs: "rfqChangeItemCtrl",
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true,
            locals: {
                headerLabel: $scope.selectedItems[0].name.value,
                item: copiedItem,
                isBuyer: false
            }
        }).then(function(data) {
            if (data && data.data) {
                $scope.selectedItems[0].price = data.data.price;
                $scope.selectedItems[0].unit = data.data.unit;
                $scope.selectedItems[0].amount = data.data.amount;
                $scope.selectedItems[0].cUnitsPerOUnit = data.data.cUnitsPerOUnit;
                $scope.selectedItems[0].contentUnit = data.data.contentUnit;
                $scope.selectedItems[0].showContentUnit = !!data.data.cUnitsPerOUnit.value || !!data.data.contentUnit.value;
                $scope.selectedItems[0].description =  data.data.description;
                $scope.selectedItems[0].name =  data.data.name;
                $scope.selectedItems[0].supplierNo =  data.data.supplierNo;
                $scope.selectedItems[0].selected = false;
                $scope.selectedItems = [];
            }
        })
    };

    self.getPrintToken = function() {
        if ($scope.selectedSupplier.length > 0) {
            var tokenIdentifier = 'rfqs-' + $scope.selectedSupplier[0].id;
            return $scope.printTokens[tokenIdentifier];
        }
        else if ($scope.data.supplierHeaders.length === 1) {
            return $scope.printTokens.first
        }
    }
}